const e = "omnichannelChatWidget/openedAction", t = "omnichannelChatWidget/closedAction", n = "omnichannelChatWidget/messageSentAction", o = () => ({
  event: "chatbot",
  event_action: "telemetry_click_opened",
  non_interaction: !1
}), c = () => ({
  event: "chatbot",
  event_action: "telemetry_click_closed",
  non_interaction: !1
}), a = () => ({
  event: "chatbot",
  event_action: "telemetry_message_sent",
  non_interaction: !1
}), s = {
  [e]: o,
  [t]: c,
  [n]: a
};
export {
  t as CLOSED_ACTION,
  n as MESSAGE_SENT_ACTION,
  e as OPENED_ACTION,
  c as closedEvent,
  s as eventsMap,
  a as messageSentEvent,
  o as openedEvent
};
//# sourceMappingURL=tracking.js.map
